import { Button } from "@mui/material";
import { ButtonProps } from ".";

export const PrimaryButton = ({ ...props }: ButtonProps) => (
  <Button variant="contained" {...props} />
);
export const SecondaryButton = ({ ...props }: ButtonProps) => (
  <Button variant="outlined" {...props} />
);
export const TextButton = ({ ...props }: ButtonProps) => <Button variant="text" {...props} />;
